export const getActionColor = (action: string): 'info' | 'success' | 'warning' | 'error' => {
  switch (action.toLowerCase()) {
    case 'created':
      return 'success';
    case 'edited':
      return 'info';
    case 'deleted':
      return 'error';
    default:
      return 'warning';
  }
};

export const formatDate = (dateStr: string) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatTime = (dateStr: string) => {
  const d = new Date(dateStr);
  return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};
